import { BasicInfoDateOfPrintComposition } from "./date";
import { BasicInfoGuestAddressOfPrintComposition } from "./guest-address";
import { BasicInfoGuestEmailOfPrintComposition } from "./guest-email";
import { BasicInfoGuestNameOfPrintComposition } from "./guest-name";
import { BasicInfoGuestNameKanaOfPrintComposition } from "./guest-name-kana";
import { BasicInfoGuestTelOfPrintComposition } from "./guest-tel";
import { BasicInfoPeopleOfPrintComposition } from "./people";
import { BasicInfoReservationIDOfPrintComposition } from "./reservation-id";
import { BasicInfoRoomNumOfPrintComposition } from "./room-num";
import { PrintSectionLayout } from "../../../layout";

import type { QueryData } from "../../../../model";

type Props = {
	// 予約番号
	reservationID: string;
	// お名前
	guestName: string;
	// ふりがな
	guestNameKana: string;
	// メールアドレス
	guestEmail: string;
	// 電話番号
	guestTel: string;
	// ご住所
	guestPostalCode: string;
	guestAddress: string;
	// 部屋数
	roomNum: number;
	// 人数
	adultNum: number;
	kidsNum: number;
	// ご宿泊日
	aliveItemsPerDate: QueryData["aliveItemsPerDate"];
	isDayTrip: boolean;
};

export const BasicInfoOfPrintComposition = ({
	reservationID,
	guestName,
	guestNameKana,
	guestEmail,
	guestTel,
	guestPostalCode,
	guestAddress,
	roomNum,
	adultNum,
	kidsNum,
	aliveItemsPerDate,
	isDayTrip,
}: Props) => {
	return (
		<PrintSectionLayout titleChildren={<p className="text-sm font-bold">基本情報</p>}>
			<div className="grid grid-cols-12">
				{/* 予約番号 */}
				<BasicInfoReservationIDOfPrintComposition reservationID={reservationID} />

				{/* お名前 */}
				<BasicInfoGuestNameOfPrintComposition guestName={guestName} />

				{/* ふりがな */}
				<BasicInfoGuestNameKanaOfPrintComposition guestNameKana={guestNameKana} />

				{/* メールアドレス */}
				<BasicInfoGuestEmailOfPrintComposition guestEmail={guestEmail} />

				{/* 電話番号 */}
				<BasicInfoGuestTelOfPrintComposition guestTel={guestTel} />

				{/* ご住所 */}
				<BasicInfoGuestAddressOfPrintComposition
					guestPostalCode={guestPostalCode}
					guestAddress={guestAddress}
				/>

				{/* 部屋数 */}
				<BasicInfoRoomNumOfPrintComposition roomNum={roomNum} />

				{/* 人数 */}
				<BasicInfoPeopleOfPrintComposition adultNum={adultNum} kidsNum={kidsNum} />

				{/* ご宿泊日 */}
				<BasicInfoDateOfPrintComposition aliveItemsPerDate={aliveItemsPerDate} isDayTrip={isDayTrip} />
			</div>
		</PrintSectionLayout>
	);
};
